import React from "react";
import TablaVentaRetail from "js/components/TablaVentaRetail";

function VentaRetail(props) {
  return <TablaVentaRetail />;
}

export default VentaRetail;
